import * as React from 'react';
import MaskedInput from 'react-text-mask';
export const DateMaskedInput = React.forwardRef((props, ref) => (React.createElement(MaskedInput, Object.assign({ mask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/] }, props, { ref: (masked) => {
        const inputEl = masked ? masked.inputElement : null;
        if (typeof ref === 'function') {
            ref(inputEl);
        }
        else if (ref && typeof ref === 'object') {
            ref.current = inputEl;
        }
    } }))));
